/// <reference path="references.ts" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var PageHomeEntryForm = /** @class */ (function () {
    //Methods
    function PageHomeEntryForm() {
        var thisObj = this;
        //console.log('Root URL: ' + GlobalRootUrl);
        //Initialize variables
        this.stores = [];
        this.storesLoaded = false;
        //console.log('variables Initialized');
        ////Link all HTML elements
        this.store_zip = document.getElementById("store_zip");
        this.store_seq = document.getElementById("store_seq");
        this.store_seq_previous = document.getElementById("store_seq_previous");
        this.store_not_found = document.getElementById("store_not_found");
        this.containerStore = document.getElementById("containerStore");
        this.containerNewStore = document.getElementById("containerNewStore");
        this.store_name_other = document.getElementById("store_name_other");
        //console.log('HTML linked store_zip ' + this.store_zip);
        //console.log('HTML linked store_seq ' + this.store_seq);
        //console.log('HTML linked store_seq_previous ' + this.store_seq_previous);
        //console.log('HTML linked store_not_found ' + this.store_not_found);
        //console.log('HTML linked containerStore ' + this.containerStore);
        //console.log('HTML linked containerNewStore ' + this.containerNewStore);
        //console.log('HTML linked');
        ////Refresh the new installer display
        this.UpdateNewStore();
        //this.SleepTest();
        //Set all input events
        this.store_zip.onkeyup = function () {
            thisObj.UpdateStoresSelect();
        };
        this.store_not_found.onchange = function () {
            thisObj.UpdateNewStore();
        };
        //Get all of the authorized installer JSON data
        //console.log('installer ajax called');
        $.ajax({
            url: GLOBALROOTURL + "/Home/JsonGetstores/",
            type: "GET",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (responseJSON) {
                //Loop through each entry and add it to the allProducts array
                for (var _i = 0, responseJSON_1 = responseJSON; _i < responseJSON_1.length; _i++) {

                    var ShopListJSON = responseJSON_1[_i];
                    var newShopListModel = new ShopListModel(ShopListJSON);
                    //console.log(ShopListJSON);
                    thisObj.stores.push(newShopListModel);
                    //console.log('pushing model' + newShopListModel);
                }
            },
            error: function (exception) { console.log('Exception:' + exception); }
        }).then(function () {
            //Flag as true to allow updates using the data
            thisObj.storesLoaded = true;
            //console.log('ajax after');
            //Do the initial select update
            thisObj.UpdateStoresSelect(true);
        });
        //console.log('installer ajax complete');
        //console.log('storesLoaded ' + this.storesLoaded); 
    }
    PageHomeEntryForm.prototype.UpdateNewStore = function () {
        //console.log('UpdateNewStore func called');
        if (this.store_not_found.checked) {
            this.containerStore.style.display = 'none';
            this.containerNewStore.style.display = '';
            this.store_name_other.required = true;
        }
        else {
            this.containerStore.style.display = '';
            this.containerNewStore.style.display = 'none';
            this.store_name_other.required = false;
        }
    };
    PageHomeEntryForm.prototype.UpdateStoresSelect = function (setToPreviousSeq) {
        //console.log('UpdateStoresSelect ' + setToPreviousSeq);
        //console.log('UpdateStoresSelect prev seq: ' + this.store_seq_previous.value);
        if (setToPreviousSeq === void 0) { setToPreviousSeq = false; }
        //Clear all entries first
        for (var i = this.store_seq.options.length - 1; i >= 0; i--) {
            this.store_seq.remove(i);
        }
        if (!this.storesLoaded) { //Default to Loading... if JSON is not yet loaded
            var newOption = document.createElement('option');
            newOption.text = 'Loading...';
            newOption.value = '';
            this.store_seq.appendChild(newOption);
        }
        else { //Only proceed if the the JSON data was loaded
            //Don't allow more than 5 characters to be entered
            if (this.store_zip.value.length > 5) {
                this.store_zip.value = this.store_zip.value.substring(0, 5);
            }
            //Prefix with zeroes to match SQL data in cases where it's an east-coast 1-4 character zip
            var formattedZip = '00000' + this.store_zip.value;
            formattedZip = formattedZip.trim();
            formattedZip = formattedZip.slice(formattedZip.length - 5, formattedZip.length);
            //Update the select options based on the zip code
            for (var _i = 0, _a = this.stores; _i < _a.length; _i++) {
                var storeList = _a[_i];
                //console.log(storeList);
                if (storeList.ShopZip === formattedZip) {
                    //console.log("storeList.store_zip === formattedZip");
                    this.store_seq.appendChild(storeList.GetAsHTMLOption());
                }
            }
            //Update the display if no authorized installers were found
            if (this.store_seq.length === 0) {
                if (formattedZip === '00000') {
                    var newOption = document.createElement('option');
                    newOption.text = "Enter your location's zip above to search.";
                    newOption.value = '';
                    this.store_seq.appendChild(newOption);
                }
                else {
                    var newOption = document.createElement('option');
                    newOption.text = 'No location found for that zipcode ' + formattedZip;
                    newOption.value = '';
                    this.store_seq.appendChild(newOption);
                }
            }
            if (this.store_seq.length === 1) {
                if (formattedZip === '77777') {
                    for (var i = this.store_seq.options.length - 1; i >= 0; i--) {
                        this.store_seq.remove(i);
                    }
                    var newOption = document.createElement('option');
                    newOption.text = 'No location found for that zipcode ' + formattedZip;
                    newOption.value = '';
                    this.store_seq.appendChild(newOption);
                }
            }
            //console.log('setToPreviousSeq start prev seq: ' + this.store_seq_previous.value);
            if (setToPreviousSeq) {
                if (this.store_seq_previous.value) {
                    this.store_seq.value = this.store_seq_previous.value;
                }
            }
            //console.log('setToPreviousSeq end');
        }
    };
    ;
    /////and end it before here
    PageHomeEntryForm.prototype.SleepTest = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Sleep test 1');
                        return [4 /*yield*/, Apfco.Sleep(2000)];
                    case 1:
                        _a.sent();
                        console.log('Sleep test 2');
                        return [4 /*yield*/, Apfco.Sleep(2000)];
                    case 2:
                        _a.sent();
                        console.log('Sleep test 3');
                        return [2 /*return*/];
                }
            });
        });
    };
    return PageHomeEntryForm;
}());
var ShopListModel = /** @class */ (function () {
    function ShopListModel(ShopListJSON) {
        //console.log('constructing vetinfo model');
        this.seq = ShopListJSON.seq;
        this.CurrentBrand = ShopListJSON.currentBrand;
        this.ShopAddress = ShopListJSON.shopAddress;
        this.ShopCity = ShopListJSON.shopCity;
        this.ShopState = ShopListJSON.shopState;
        this.ShopZip = ShopListJSON.shopZip;
        this.LandlineNumber = ShopListJSON.landlineNumber;
        this.ShopNumber = ShopListJSON.shopNumber;
    }
    ShopListModel.prototype.GetAddressAsHTMLOption = function () {
        var output = document.createElement('option');
        output.text = this.shopAddress;
        output.value = this.seq.toString();
        //console.log('get as HTML option output' + output);
        return output;
    };
    ShopListModel.prototype.GetCityAsHTMLOption = function () {
        var output = document.createElement('option');
        output.text = this.shopCity;
        output.value = this.seq.toString();
        //console.log('get as HTML option output' + output);
        return output;
    };
    ShopListModel.prototype.GetStateAsHTMLOption = function () {
        var output = document.createElement('option');
        output.text = this.shopState;
        output.value = this.seq.toString();
        //console.log('get as HTML option output' + output);
        return output;
    };
    ShopListModel.prototype.GetNameAsHTMLOption = function () {
        var output = document.createElement('option');
        output.text = this.currentBrand;
        output.value = this.seq.toString();
        //console.log('get as HTML option output' + output);
        return output;
    };
    ShopListModel.prototype.GetAsHTMLOption = function () {
        var output = document.createElement('option');
        output.text = this.ShopAddress + ', ' + this.ShopCity + ', ' + this.ShopState;
        output.value = this.seq.toString();
        //console.log('get as HTML option output' + output);
        return output;
    };
    return ShopListModel;
}());
//# sourceMappingURL=PageHomeEntryForm.js.map